<template>
  <table class="details" role="presentation">
    <tbody>
    <tr class="mobile-hidden tablet-hidden">
      <td class="sq-ft">{{ currentRoomSqFt }} sq. ft.</td>
      <td class="bed">{{ currentRoomBedType }}<br />{{ currentRoomBedCount }}</td>
      <td class="bath">{{ currentRoomBathCount }}</td>
      <td class="smoking">
        <quick-details-smoking></quick-details-smoking>
      </td>
      <td class="ada" v-if="false !== checkIfRoomTypeVariantExists('ROOM_ADA', true, 0)">
        <quick-details-ada></quick-details-ada>
      </td>
    </tr>
    <tr class="mobile-only tablet-only">
      <td class="sq-ft" colspan="2">{{ currentRoomSqFt }} sq. ft.</td>
      <td class="bed" colspan="2">{{ currentRoomBedType }}<br />{{ currentRoomBedCount }}</td>
      <td class="bath" colspan="2">{{ currentRoomBathCount }}</td>
    </tr>
    <tr class="mobile-only tablet-only">
      <td class="smoking" colspan="3">
        <quick-details-smoking></quick-details-smoking>
      </td>
      <td class="ada" colspan="3" v-if="false !== checkIfRoomTypeVariantExists('ROOM_ADA', true, 0)">
        <quick-details-ada></quick-details-ada>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import {mapState} from 'vuex';
import {defineComponent} from "vue";
import {ViewRoomDetailsHotelRoomData} from "../hotel/defs";
import QuickDetailsAda from "./quick-details-ada.vue";
import QuickDetailsSmoking from "./quick-details-smoking.vue";

export default defineComponent({
  name: "view-room-details-quick-details",
  components: {QuickDetailsSmoking, QuickDetailsAda},
  props: {},
  computed: {
    ...mapState([
        'defaultDisplayData',
        'roomData'
    ]),
    currentRoomSqFt(): string {
      return this.getRoomTypeDisplayData(this.$store.getters.currentRoomType, 'SQ_FT');
    },
    currentRoomBedType(): string {
      return this.getRoomTypeDisplayData(this.$store.getters.currentRoomType, 'BED_TYPE');
    },
    currentRoomBedCount(): string {
      return this.getRoomTypeDisplayData(this.$store.getters.currentRoomType, 'BED_COUNT');
    },
    currentRoomBathCount(): string {
      return this.getRoomTypeDisplayData(this.$store.getters.currentRoomType, 'BATH_COUNT');
    },
  },
  methods: {
    getRoomTypeDisplayData(roomTypeData: ViewRoomDetailsHotelRoomData, dataKey: 'SQ_FT' | 'BED_TYPE' | 'BED_COUNT' | 'BATH_COUNT'): string {
      if (roomTypeData && 'DISPLAY' in roomTypeData && dataKey in roomTypeData.DISPLAY) {
        return '' + roomTypeData.DISPLAY[dataKey];
      }
      return '' + this.$store.state.defaultDisplayData[dataKey] || '';
    },
    checkIfRoomTypeVariantExists(dataKey: string, dataValue: boolean, omitPrtId = 0, valueModifierFunction = (val: string) => val) {
      for (let i = 0, l = this.$store.state.roomData.length; i < l; i++) {
        if (this.$store.state.roomData[i].PRT_ID !== omitPrtId && 'DISPLAY' in this.$store.state.roomData[i] && dataKey in this.$store.state.roomData[i].DISPLAY && dataValue === valueModifierFunction(this.$store.state.roomData[i].DISPLAY[dataKey])) {
          return parseInt(this.$store.state.roomData[i].PRT_ID, 10);
        }
      }
      return false;
    }
  }
})
</script>

<style scoped>

</style>